import SearchSection from './SearchSection';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  getIsTrialEligible,
  getSubscriptionType,
  playPlaylistSelector,
  songToStartSelector,
} from 'state/Entitlements/selectors';
import { localize } from 'redux-i18n';
import { setSearchFilter } from 'state/Search/actions';

const mapStateToProps = createStructuredSelector({
  canPlayPlaylist: playPlaylistSelector,
  isTrialEligible: getIsTrialEligible,
  song2Start: songToStartSelector,
  subscriptionType: getSubscriptionType,
});

export default localize('translate')(
  connect(mapStateToProps, {
    setSearchFilter,
  })(SearchSection)
);
